import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // Start with 15 minutes in seconds
  const initialTime = 15 * 60;
  const [timeLeft, setTimeLeft] = useState(initialTime);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 md:gap-4 text-white font-oswald text-4xl md:text-6xl font-bold" data-id="element-66">
      <div className="flex flex-col items-center bg-brand-card p-4 rounded-lg min-w-[80px] md:min-w-[120px] border border-gray-800" data-id="element-67">
        <span data-id="element-68">{formatTime(minutes)}</span>
        <span className="text-xs md:text-sm text-brand-red uppercase tracking-widest mt-1" data-id="element-69">
          Minutos
        </span>
      </div>
      <span className="text-brand-red pb-6" data-id="element-70">:</span>
      <div className="flex flex-col items-center bg-brand-card p-4 rounded-lg min-w-[80px] md:min-w-[120px] border border-gray-800" data-id="element-71">
        <span data-id="element-72">{formatTime(seconds)}</span>
        <span className="text-xs md:text-sm text-brand-red uppercase tracking-widest mt-1" data-id="element-73">
          Segundos
        </span>
      </div>
    </div>;
}